import { accountApi as apiService } from './api';

/**
 * Usage data — credits-only model (Wave B). Endpoint is hit via
 * `/billing/info?detailed=true` rather than `/usage` directly so we
 * don't have to add a new API Gateway route in prod CDK; billing.js
 * delegates to handlers/usage.getUsage when detailed=true.
 *
 * Response shape:
 *   { window, windowStart, windowEnd,
 *     balance: { milliCents, usd },
 *     burn: { totalMilliCents, byCategory, daily },
 *     recentExecutions: [...] }
 */
class UsageService {
  async getUsage(window = '30d') {
    try {
      return await apiService.request(
        `/billing/info?detailed=true&window=${encodeURIComponent(window)}`
      );
    } catch (error) {
      console.error('Error fetching usage:', error);
      return {
        window,
        windowStart: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString(),
        windowEnd: new Date().toISOString(),
        balance: { milliCents: 0, usd: 0 },
        burn: { totalMilliCents: 0, byCategory: {}, daily: [] },
        recentExecutions: [],
      };
    }
  }
}

const usageService = new UsageService();
export default usageService;
